<template>
    <div class="full-page-loading">
        <div class="full-page-loading-spin">
            <a-spin size="large" :tip="text" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "PageLoading",
        props: {
            text: {
                default: 'Loading...'
            }
        }
    }
</script>

<style scoped lang="less">
    .full-page-loading {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #F4F4F4;
        opacity: 0.8;

        .full-page-loading-spin {
            margin: auto;
            text-align: center;
            top: 40%;
            position: absolute;
            width: 100%;
            transform: translateY(-50%);
        }

    }
</style>
